import { DataV2API } from "../Endpoints";

class Blacklist {
    getAll() {
        return DataV2API.get("/blacklist");
    }

    addTo(blacklists) {
        return DataV2API.post("/blacklist/add", blacklists);
    }

    deleteFrom(blacklists) {
        return DataV2API.post("/blacklist/remove", blacklists);
    }
}

export default new Blacklist();
